module.exports = __webpack_public_path__ + "img/Kuwait-Portrait-arabic.80c0b1ab.jpg";